import {
  ChangeDetectionStrategy,
  Component,
} from '@angular/core';
import { AgRendererComponent } from 'ag-grid-angular';
import { BaseRendererComponent } from '../base-renderer.component';
import { compact, flatten, get, isFunction } from 'lodash';
import { IEntitySummaryRendererParams } from '@app/shared/types';

@Component({
  selector: 'xea-entity-summary-renderer',
  templateUrl: './entity-summary-renderer.component.html',
  styleUrls: ['./entity-summary-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EntitySummaryRendererComponent extends BaseRendererComponent
  implements AgRendererComponent
{
  public declare params: IEntitySummaryRendererParams;
  public panelClass: string | string[] = '';
  public rowClass: string | string[] = '';
  public containerClasses: string[] = [];
  public title = '';
  public subTitle = '';

  public constructor() {
    super();
  }

  public refresh(): boolean {
    return false;
  }

  public agInit(params: IEntitySummaryRendererParams): void {
    this.params = params;

    this.panelClass = get(this.params, 'panelClass', '');
    this.title = get(this.params, 'value', '');
    this.subTitle = this.getSubTitle();
    this.rowClass = isFunction(this.params.getRowClass)
      ? this.params.getRowClass(this.params)
      : '';

    // Either class input may itself be an array, and NgClass rejects nested arrays.
    this.containerClasses = compact(flatten([this.panelClass, this.rowClass]));
  }

  public onCellClick(event: MouseEvent): void {
    if (isFunction(this.params?.onClick)) {
      this.params.onClick(this.params, event);
    }
  }

  private getSubTitle(): string {
    if (isFunction(this.params.getSubTitle)) {
      return this.params.getSubTitle(this.params);
    }

    return get(this.params, ['data', this.params.subTitleField], '');
  }
}
